<template>
  <template v-if="!isEmpty(label)">
    <Tooltip v-if="isTruncated" :title="label" :delay="300" side="right">
      <Id v-if="label" :label="label" class="shrink-0" :size="size" />
    </Tooltip>
    <Id v-else ref="element" :label="label" :size="size" />
  </template>
  <span
    v-else
    :class="
      cn('text-placeholder_subtle', {
        capitalize: type === 'property',
        'text-xs font-medium': type === 'table',
      })
    "
  >
    {{ placeholder }}
  </span>
</template>

<script setup>
// Vue utilities
import { onMounted, ref, watch } from "vue";

// Importing utility libraries
import { isEmpty } from "lodash";
import { cn } from "@/Utils/cn";

// Utils
import { isTruncating } from "@/Utils/truncate";
import { debounce } from "lodash";

// Refs
const element = ref(null);
const isTruncated = ref(false);

// Components
import { Tooltip } from "@/SharedComponents/Tooltips";
import { Id } from "@/SharedComponents/Badges";

// Define Props
const props = defineProps({
  label: { type: String, default: null },
  placeholder: { type: String, default: "" },
  size: { type: String, default: "sm" },
  listeners: { type: Array, default: () => [] },
});

// Functions
const handleTruncation = () => {
  if (element.value) {
    isTruncated.value = isTruncating(element.value.$el.querySelector("span"));
  }
};

const debounceHandleTruncation = debounce(() => {
  handleTruncation();
}, 100);

// Lifecycle Hooks
onMounted(() => {
  handleTruncation();
});

// Watcher
watch(
  () => props.listeners,
  () => {
    debounceHandleTruncation();
  },
  { deep: true }
);
</script>
